import React from "react";
import { ShareApplicationPerson } from "@/types/ShareApplication";
import { getShareApplicationRoleDisplayName, getUserAccountStatusDisplayName } from "@/types/enums";
import { SecondaryButton } from "@ucl/library";
import { faShare, faLink } from "@fortawesome/free-solid-svg-icons";
import { UserAccountStatus } from "@/types/enums";
import "./ShareApplicationPeopleTable.scss";

export interface ShareApplicationPeopleTableProps {
  people: ShareApplicationPerson[];
  onShareClick?: (person: ShareApplicationPerson) => void;
}

export const ShareApplicationPeopleTable: React.FC<ShareApplicationPeopleTableProps> = ({
  people,
  onShareClick,
}) => {
  const getActionButtonProps = (person: ShareApplicationPerson) => {
    if (person.userAccountStatus === UserAccountStatus.Unlinked && person.potentialUserId) {
      return {
        icon: faLink,
        title: "Link to existing account",
      };
    }
    return {
      icon: faShare,
      title: "Share application",
    };
  };

  if (people.length === 0) {
    return (
      <div className="share-application-people-table__empty-state">
        No people found to share with.
      </div>
    );
  }

  return (
    <table className="share-application-people-table__table">
      <thead>
        <tr className="share-application-people-table__header">
          <th className="share-application-people-table__header-cell">Full Name</th>
          <th className="share-application-people-table__header-cell">Role</th>
          <th className="share-application-people-table__header-cell">Email Address</th>
          <th className="share-application-people-table__header-cell">User Account Status</th>
          <th className="share-application-people-table__header-cell">Action</th>
        </tr>
      </thead>
      <tbody>
        {people.map((person, index) => {
          const actionProps = getActionButtonProps(person);
          return (
            <tr key={index} className="share-application-people-table__row">
              <td className="share-application-people-table__cell">{person.fullName}</td>
              <td className="share-application-people-table__cell">
                {getShareApplicationRoleDisplayName(person.role)}
              </td>
              <td className="share-application-people-table__cell">{person.emailAddress}</td>
              <td className="share-application-people-table__cell">
                {getUserAccountStatusDisplayName(person.userAccountStatus)}
              </td>
              <td className="share-application-people-table__cell">
                <SecondaryButton
                  text=""
                  // color="forest-green"
                  iconProps={{
                    icon: actionProps.icon,
                  }}
                  title={actionProps.title}
                  onClick={() => {
                    onShareClick?.(person);
                  }}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default ShareApplicationPeopleTable;
